import { render } from "./InitialMenu.vue?vue&type=template&id=05d91139&ts=true"
import script from "./InitialMenu.vue?vue&type=script&lang=ts"
export * from "./InitialMenu.vue?vue&type=script&lang=ts"

import "./InitialMenu.vue?vue&type=style&index=0&id=05d91139&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__